import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-12 text-center">
            Mentions légales
          </h1>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Éditeur du site</h2>
              <p className="text-gray-700">
                <strong>Nom du site :</strong> Giletau<br />
                <strong>Responsable de la publication :</strong> Équipe Giletau<br />
                <strong>Email :</strong> contact@giletau.fr
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Hébergement</h2>
              <p className="text-gray-700">
                Le site Giletau est hébergé par un prestataire professionnel respectant les normes en vigueur en matière de sécurité et de protection des données.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Propriété intellectuelle</h2>
              <p className="text-gray-700 mb-4">
                L'ensemble des contenus présents sur le site Giletau (textes, images, logos, graphismes) est protégé par le droit d'auteur.
              </p>
              <p className="text-gray-700">
                Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans l'autorisation préalable de Giletau est strictement interdite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Limitation de responsabilité</h2>
              <p className="text-gray-700 mb-4">
                Giletau s'efforce de fournir des informations exactes et vérifiées. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité de toutes les informations diffusées.
              </p>
              <p className="text-gray-700">
                L'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive. Giletau ne saurait être tenu responsable des décisions prises sur la base des informations fournies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Liens hypertextes</h2>
              <p className="text-gray-700">
                Le site peut contenir des liens vers d'autres sites internet. Giletau n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#1a1a1a] mb-4">Droit applicable</h2>
              <p className="text-gray-700">
                Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l'utilisation du site Giletau sera soumis aux tribunaux compétents français.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
